<template>
  <div class="list-section">
    <div class="search-bg">
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="searchForm">
        <el-row :gutter="24">
          <el-col :span="5">
            <el-form-item :label="$t('proxy.text153') + '：'" class="search-label" style="width: 80%;">
              <el-select clearable v-model="searchForm.status" placeholder="">
                <el-option :label="$t('proxy.text95')" value="" />
                <el-option :label="$t('proxy.text293')" value="0" />
                <el-option :label="$t('proxy.text297')" value="4" />
                <el-option :label="$t('proxy.text294')" value="1" />
                <el-option :label="$t('proxy.text295')" value="2" />
                <el-option :label="$t('proxy.text296')" value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('proxy.text158') + '：'" class="search-label" style="width: 160%;">
              <el-date-picker
                v-model="searchForm.applyTimeRange"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('proxy.text201')"
                :end-placeholder="$t('proxy.text202')"
                placeholder=""
                format="MM/DD/YYYY"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2" />
          <el-col :span="2">
            <el-form-item>
              <el-button type="primary" @click="onSearch" class="search-button">{{ $t('proxy.text13') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 概览 -->
    <div class="overview-container">
      <el-row>
        <span class="summary-title">{{ $t('proxy.text264') }}：<span class="summary-text">{{stat.totalCommission}} USD</span></span>
        <span class="summary-title">{{ $t('proxy.text160') }}：<span class="summary-text">{{stat.balance}} USD</span></span>
        <span class="summary-title">{{ $t('proxy.text161') }}：<span class="summary-text">{{stat.totalWithdraw}} USD</span></span>
      </el-row>

      
    </div>

    <el-row style="padding-left: 40px; padding-bottom: 8px;">
      <el-col>
        <el-button @click="openWithdrawDialog" type="primary" class="withdraw-button">{{ $t('proxy.text162') }}</el-button>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <div class="table-container">
      <el-table :data="filteredData" style="width: 100%">
        <el-table-column prop="transferfundsid" label="ID" align="center" />
        <el-table-column prop="amount" :label="$t('proxy.text164')" align="center" />
        <el-table-column prop="receiverStr" :label="$t('proxy.text262')" align="center" />
        <el-table-column prop="receiverAccountId" :label="$t('proxy.text263')" align="center" />
        <el-table-column prop="statusStr" :label="$t('proxy.text153')" align="center" />
        <el-table-column prop="applicationtime" :label="$t('proxy.text158')" align="center" />
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @current-change="handlePageChange"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        :page-size="pageSize"
        :total="totalEntries"
        :page-sizes="[10, 50, 100, 200]"
        :disabled="false"
        :background="true"
        layout="total, prev, pager, next, sizes"
        class="pagination-container"
      />
    </div>

     <!-- 提现对话框 -->
     <el-dialog 
        :title="$t('proxy.text151')" 
        v-model="withdrawDialogVisible" 
        width="480px" 
        show-close="true"
        :close-on-click-modal="false" 
        @close="resetWithdrawForm"
      >
        <div class="withdraw-dialog-content">
          <el-form :model="withdrawForm" label-width="auto">
            <el-form-item :label="$t('proxy.text261') + '：'" class="withdraw-label">
              <el-col :span="16" class="dialog-value">{{ stat.totalCommission }} USD</el-col>
            </el-form-item>
            <el-form-item :label="$t('proxy.text160') + '：'" class="withdraw-label">
              <el-col :span="16" class="dialog-value">{{ stat.balance }} USD</el-col>
            </el-form-item>
            <el-form-item :label="$t('proxy.text265') + '：'" class="withdraw-label">
              <el-input v-model="withdrawForm.amount" placeholder=""></el-input>
            </el-form-item>
            <el-form-item :label="$t('proxy.text262') + '：'" class="withdraw-label">
              <el-select v-model="withdrawForm.accountType" placeholder="" @change="fetchAccounts">
                <el-option :label="$t('proxy.text111')" value="web" />
                <el-option :label="$t('proxy.text216')" value="mt4" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('proxy.text263') + '：'" class="withdraw-label">
              <el-select v-model="withdrawForm.receiverAccountId" placeholder="">
                <el-option
                  v-for="account in accountList"
                  :key="account.id"
                  :label="account.name"
                  :value="account.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="withdrawDialogVisible = false">{{$t('proxy.text167')}}</el-button>
          <el-button type="primary" @click="handleWithdraw">{{$t('trade.text73')}}</el-button>
        </span>
      </el-dialog>

  </div>
</template>

<script>
import apiService from '@/api/request'; // 假设你的apiService路径是这样

export default {
  data() {
    return {
      searchForm: {
        status: '',
        applyTimeRange: [],
      },
      withdrawForm: {
        amount: '',
        accountType: '', // Web or MT4
        receiverAccountId: '',
      },
      stat: {
        totalCommission: 0,
        balance: 0,
        totalWithdraw: 0,
      },
      filteredData: [],
      currentPage: 1,
      pageSize: 10,
      totalEntries: 0,
      withdrawDialogVisible: false,
      accountList: [], // 用于存储从接口获取到的账号列表
    };
  },
  mounted() {
    this.fetchCommissionList();
    
  },
  methods: {
    // 获取佣金提取列表
    fetchCommissionList() {
      const params = {
        page: this.currentPage,
        limit: this.pageSize,
        status: this.searchForm.status || null,
        startTime: this.searchForm.applyTimeRange ? (this.searchForm.applyTimeRange.length ? this.searchForm.applyTimeRange[0] : '') : '',
        endTime: this.searchForm.applyTimeRange ? (this.searchForm.applyTimeRange.length ? this.searchForm.applyTimeRange[1] : '') : '',
      };

      apiService.proxyTransferFundList(params)
        .then((response) => {
          if (response.status === 1) {
            this.filteredData = response.data.list;
            this.stat = response.data.statis;
            this.totalEntries = response.data.count;
          } else {
            this.$message.error('获取佣金提取列表失败');
          }
        })
        .catch(() => {
          this.$message.error('请求失败');
        });
    },
    // 获取账户列表
    fetchAccounts(accountType) {
      // 清空 receiverAccountId
      this.withdrawForm.receiverAccountId = '';
      
      apiService.proxyAccountList({ accountType })
        .then((response) => {
          if (response.status === 1) {
            this.accountList = response.data[accountType];
          } else {
            this.$message.error('获取账户列表失败');
          }
        })
        .catch(() => {
          this.$message.error('请求账户列表失败');
        });
    },
    onSearch() {
      this.currentPage = 1;
      this.fetchCommissionList();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchCommissionList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchCommissionList();
    },
    openWithdrawDialog() {
      this.withdrawDialogVisible = true;
    },
    // 提交佣金提取申请
    handleWithdraw() {
      const params = {
        amount: this.withdrawForm.amount,
        receiver: this.withdrawForm.accountType === 'web' ? 1 : 6, // 1表示Web账号，6表示MT4账号
        receiverAccountId: this.withdrawForm.receiverAccountId,
      };

      const amountNumber = Number(params.amount);
      // withdrawForm.amount如果不是纯数字，提示proxy.text288
      if (isNaN(amountNumber)) {
        this.$message.error(this.$t('proxy.text288'));
        return;
      }

      if (!amountNumber || !params.receiver || !params.receiverAccountId) {
        this.$message.error(this.$t('proxy.text286'));
        return;
      }

      // 判断金额是否小于0.01
      if (amountNumber < 0.01) {
        this.$message.error(this.$t('proxy.text288'));
        return;
      }

      // 判断金额是否小于可提金额
      if (amountNumber > parseFloat(this.stat.balance)) {
        this.$message.error(this.$t('followOrder.text117'));
        return;
      }
      
      apiService.proxyCommissonApply(params)
        .then((response) => {
          if (response.status === 1) {
            this.$message.success(this.$t('proxy.text175'));
            this.withdrawDialogVisible = false;
            this.fetchCommissionList(); // 重新获取列表
          }
          else if(response.status === -1) {
            this.$message.error(response.message);
          }
           else {
            this.$message.error(this.$t('proxy.text176'));
          }
        })
        .catch(() => {
          this.$message.error(this.$t('proxy.text176'));
        });
    },
    resetWithdrawForm() {
      this.withdrawForm.amount = '';
      this.withdrawForm.accountType = '';
      this.withdrawForm.receiverAccountId = '';
    },
  },
};
</script>

<style lang="less" scoped>

.dialog-footer {
  padding-top: 38px;
  display: flex;
  justify-content: right;
}

.withdraw-dialog-content {
  padding: 10px 0;
}

.withdraw-label .el-form-item__label {
  white-space: nowrap; /* 禁止换行 */
  text-align: right; /* 确保文字靠右对齐 */
  padding-right: 10px; /* 添加一些右边距 */
}
</style>
